module.exports = __webpack_public_path__ + "img/ai-companion.d4250854.svg";